module.exports = __webpack_public_path__ + "static/media/dematAccount.d48cafb1.svg";